export type FeatureVideo = {
  id: string;
  kind: string;
  title: string;
  frameTitle: string;
  description: string;
  icon: string;
  chapterTitle: string;
  chapterLabel: string;
};

export const YOUTUBE_ID_PATTERN = /^[A-Za-z0-9_-]{11}$/;

export const FEATURE_VIDEOS: FeatureVideo[] = [
  {
    id: '0eQxJsvpv7U',
    kind: 'Platform overview',
    title: 'Why choose AACore Booking?',
    frameTitle: 'Why choose AACore Booking for your service business?',
    description: 'A concise founder Q&A about the website, booking, quotes, customer conversations, invoices, payments, and the ways service businesses work.',
    icon: 'spark',
    chapterTitle: 'Why choose AACore',
    chapterLabel: 'The connected platform',
  },
  {
    id: 'QnJLmTdTJLk',
    kind: 'Real salon example',
    title: 'A conversation becomes an appointment.',
    frameTitle: 'A conversation becomes an appointment.',
    description: 'At Sunflower Nails, a customer describes a dipping manicure, chooses an available time, reviews the details, and confirms the booking.',
    icon: 'calendar',
    chapterTitle: 'Sunflower Nails',
    chapterLabel: 'AI-assisted booking',
  },
  {
    id: '9gErWdPB_Bc',
    kind: 'Founder-led invitation',
    title: 'Build your service business.',
    frameTitle: 'Build your service business.',
    description: "Nathan's AI avatar introduces a practical path from a service skill to a business customers can find and book.",
    icon: 'team',
    chapterTitle: 'Build your business',
    chapterLabel: 'From skill to storefront',
  },
  {
    id: 'R3CKgo0ufHw',
    kind: 'Workflow walkthrough',
    title: 'Move custom work from quote to schedule.',
    frameTitle: 'Move custom work from quote to schedule.',
    description: 'Follow a quote request through the in-app conversation, offer, acceptance, appointment, and deposit deadline.',
    icon: 'chat',
    chapterTitle: 'Quote to appointment',
    chapterLabel: 'A complete workflow',
  },
];

export const HOME_VIDEOS: FeatureVideo[] = [
  {
    id: '0eQxJsvpv7U',
    kind: 'Platform overview',
    title: 'Why Choose AACore Booking for Your Service Business?',
    frameTitle: 'Why Choose AACore Booking for Your Service Business?',
    description: 'A founder Q&A about using AACore Booking for a service business.',
    icon: 'spark',
    chapterTitle: 'Why choose AACore',
    chapterLabel: 'For your service business',
  },
  {
    id: 'YyV4OIUT6zU',
    kind: 'AACore Booking with AI',
    title: 'Big Plans. Small Business Budget. | AACore Booking with AI',
    frameTitle: 'Big Plans. Small Business Budget. | AACore Booking with AI',
    description: 'How AACore Booking with AI helps small businesses grow without a large budget.',
    icon: 'wallet',
    chapterTitle: 'Small business budget',
    chapterLabel: 'AACore Booking with AI',
  },
  {
    id: 'W378bq9tI34',
    kind: 'Is it a fit?',
    title: 'Will a Booking Platform Fit Your Business? See AACore Booking',
    frameTitle: 'Will a Booking Platform Fit Your Business? See AACore Booking',
    description: 'See whether a booking platform like AACore Booking fits the way you work.',
    icon: 'store',
    chapterTitle: 'Fit your business',
    chapterLabel: 'See AACore Booking',
  },
  {
    id: 'UVAX4EotuCU',
    kind: 'All in one',
    title: 'Website, AI Booking & Payments in One | Try AACore Free',
    frameTitle: 'Website, AI Booking & Payments in One | Try AACore Free',
    description: 'Website, AI booking, and payments in one place. Try AACore free.',
    icon: 'stack',
    chapterTitle: 'Website, AI & payments',
    chapterLabel: 'Try AACore free',
  },
];
